var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.1933 0 0 11.1933 0 25C0 38.8067 11.1933 50 25 50C38.8067 50 50 38.8067 50 25C50 11.1933 38.8067 0 25 0ZM18.2692 36.5385H13.4615V19.2308H18.2692V36.5385ZM15.851 17.3077H15.824C14.3894 17.3077 13.4615 16.2385 13.4615 14.9029C13.4615 13.5385 14.4183 12.5 15.8788 12.5C17.3413 12.5 18.2423 13.5385 18.2692 14.9029C18.2692 16.2375 17.3413 17.3077 15.851 17.3077ZM36.5385 36.5385H31.7308V27.8846C31.7308 25 30.3404 24.0385 28.8462 24.0385C27.4567 24.0385 25.9615 25 25.9615 27.8846V36.5385H21.1538V19.2308H25.9615V22.1154C26.2913 21.1721 27.8692 19.2308 30.7692 19.2308C34.6154 19.2308 36.5385 22.1154 36.5385 26.9231V36.5385Z",
    fill: "#2B4A99"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0f6834fc7964a8b5cbb11fa128c4c633.svg";
export { ForwardRef as ReactComponent };